import _ from "underscore";
import UNINITIALISED from "utils/uninitialised";
import {MaybeUninitialised} from "modules/redux_types";
import {GetLlmRunAction} from "../actions/llm_run_fetch";
import {WorkflowTestAddAction} from "../actions/workflow_test_add";
import {WorkflowTestUpdateAction} from "../actions/workflow_test_update";
import {WorkflowTestResultFetchAction} from "../actions/workflow_test_results_fetch";
import actionTypes from "../constants/action_types";
import {EnhancedLlmRun} from "common/flowmaster/types/llm_run";
import {WorkflowTestDeleteAction} from "../actions/workflow_test_delete";

export default function llmRunReducer(
  state: MaybeUninitialised<EnhancedLlmRun> = UNINITIALISED,
  action:
    | GetLlmRunAction
    | WorkflowTestAddAction
    | WorkflowTestUpdateAction
    | WorkflowTestDeleteAction
    | WorkflowTestResultFetchAction,
): typeof state {
  if (action.type === actionTypes.LLM_RUN_FETCH.SUCCESS) {
    return (action as GetLlmRunAction).payload;
  }
  if (
    action.type === actionTypes.WORKFLOW_TEST_ADD.SUCCESS ||
    action.type === actionTypes.WORKFLOW_TEST_UPDATE.SUCCESS ||
    action.type === actionTypes.WORKFLOW_TEST_DELETE.SUCCESS
  ) {
    if (
      state !== UNINITIALISED &&
      _.isEqual(state.links, action.payload.links)
    ) {
      return {...state, tests: action.payload.tests};
    }
  }
  if (action.type === actionTypes.WORKFLOW_TEST_RESULT_FETCH.SUCCESS) {
    // put payload into state.testResults
    if (state !== UNINITIALISED) {
      const {dataKey, key, results} = action.payload;
      const dataKeyData =
        state.test_results && dataKey in state.test_results
          ? state.test_results[dataKey]
          : {};
      return {
        ...state,
        test_results: {
          ...state.test_results,
          [action.payload.dataKey]: {
            ...dataKeyData,
            [key]: results,
          },
        },
      };
    }
  }
  return state;
}
